import { z } from 'zod';

export const zodLabelingPostprocessingReportSchema = z.object({
  projectName: z.string().min(1),
});
